<script>
import Vue from 'vue'
import Layout from './Layout'
import Drawer from './Drawer'
import ToolbarTitle from './ToolbarTitle'
import Radio from './Radio'
import Checkbox from './Checkbox'
import Progress from './Progress'
import Dropdown from './Dropdown'
import FormDropdown from './FormDropdown'
import DatePicker from './Datepicker'
import Vlist from './Vlist'
import TimeInput from './TimeInput'
import Upload from './Upload'
import Paginate from './Paginate'
import TreeItem from './TreeItem'
import Select from './Select'
import Table from './Table'
import Input from './Input'
import Modal from './Modal'
// import Platform from './features/platform'

Vue.component('v-layout', Layout)
Vue.component('v-drawer', Drawer)
Vue.component('v-toolbar-title', ToolbarTitle)
Vue.component('v-radio', Radio)
Vue.component('v-checkbox', Checkbox)
Vue.component('v-progress', Progress)
Vue.component('v-dropdown', Dropdown)
Vue.component('v-form-dropdown', FormDropdown)
Vue.component('v-datepicker', DatePicker)
Vue.component('v-list', Vlist)
Vue.component('v-time-input', TimeInput)
Vue.component('v-file-input', Upload)
Vue.component('v-pagination', Paginate)
Vue.component('v-tree-item', TreeItem)
Vue.component('v-select', Select)
Vue.component('v-table', Table)
Vue.component('v-input', Input)
Vue.component('v-modal', Modal)

// if (Platform.has.touch) {
// window.dom_ready(function () {
//   FastClick.attach(document.body)
// console.log('FastClick')
// })
// }
export default {}
</script>
<style>
</style>
